export default {
  alerts: {
    title: "Avisos por correo",
    errorPrefix: "Error: ",
    alertCreated: "Aviso creado",
    loadError: "No se pudo cargar la información. Comprueba tu conexión.",
    retry: "Reintentar",
    tabMyAlerts: "Mis avisos ({n})",
    tabHistory: "Historial ({n})",
    tabEmailPrefs: "Preferencias de email",
    newSubscription: "Nueva suscripción de avisos",
    changeType: "Tipo de cambio",
    any: "Cualquiera",
    activeIngredient: "Principio activo",
    activeIngredientPlaceholder: "p.ej. Progesterona",
    minRelevance: "Relevancia mín.",
    create: "+ Crear",
    thType: "Tipo",
    thActiveIngredient: "P. Activo",
    thMinRelevance: "Relevancia mín.",
    thCreated: "Creada",
    thStatus: "Estado",
    noSubs: "Sin avisos configurados",
    active: "Activa",
    paused: "Pausada",
    delete: "Eliminar",
    logChangeId: "Evento ID",
    logChannel: "Canal",
    logStatus: "Estado",
    logSent: "Enviada",
    logError: "Error",
    noLog: "Sin historial de avisos",
    types: {
      new_entry: "Nueva entrada",
      price_change: "Cambio precio",
      reimbursement_change: "Financiación",
      exclusion: "Exclusión",
      deduction: "Deducción",
      warning: "Nota",
      marketing_status: "Comercialización",
      eu_registration: "Registro europeo",
      regulation: "Normativa",
      exclusivity: "Exclusividad",
    },
    sevTitle: "Qué avisos te llegan por correo",
    sevIntro: "Según el nivel que tiene cada hito en la tabla de severidad de tu organización, para tus productos y para tu competencia. Lo que llega destacado como «[CRÍTICO]» no lo decide el nivel sino la marca de alerta crítica de cada hito (en Severidad).",
    sevLink: "Ver la tabla de severidad →",
    sevLevel: "Nivel",
    sevOwn: "Tu portfolio",
    sevCompetitor: "Tu competencia",
    sevNote: "Lo que no marques sigue en Eventos y en la bandeja de Avisos: solo deja de llegar por correo.",
    lvlA: "A · Hay un plazo: actúa",
    lvlD: "D · Valora si te afecta",
    lvlI: "I · Solo para tu información",
    prefsIntro: "Elige qué avisos recibes por correo a la dirección asociada a tu cuenta.",
    prefsLoadError: "No se pudieron cargar las preferencias",
    prefsSaved: "Preferencias guardadas",
    prefsSaveError: "Error al guardar",
    loading: "Cargando…",
    noPrefs: "No hay preferencias disponibles para tu rol.",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
  },
};
